import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL as string
const key = import.meta.env.VITE_SUPABASE_ANON_KEY as string

// Type safety is enforced at the service layer via explicit casts to Db* types.
export const supabase = createClient(url, key)

export async function getUserHouseholdId(userId: string): Promise<string | null> {
  const { data } = await supabase
    .from('household_members')
    .select('household_id')
    .eq('user_id', userId)
    .single()
  return data?.household_id ?? null
}

export async function getHouseholdName(householdId: string): Promise<string | null> {
  const { data } = await supabase
    .from('households')
    .select('name')
    .eq('id', householdId)
    .single()
  return data?.name ?? null
}

export async function getHouseholdMembers(householdId: string): Promise<{ user_id: string }[]> {
  const { data } = await supabase
    .from('household_members')
    .select('user_id')
    .eq('household_id', householdId)
  return data ?? []
}

export async function getHouseholdMemberProfiles(householdId: string): Promise<{ user_id: string; display_name: string }[]> {
  const { data } = await supabase.rpc('get_household_member_profiles', { p_household_id: householdId })
  return data ?? []
}
